export default __webpack_public_path__ + "static/media/down.f7cff736.svg";